import { create } from 'zustand';

export const useAuthStore = create((set) => ({
    auth: {
        email: '',  // Changed from 'email' to 'email'
        active: false
    },
    setEmail: (email) => set((state) => ({ auth: { ...state.auth, email } })) // Updated function name & reference
}));
